import type { ReactNode } from 'react';

import { Heading } from '@/modules/ui/components/heading/Heading';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

interface ErrorPageProps {
  title: string;
  message: ReactNode;
  icon: ReactNode;
  actions?: ReactNode;
}

export const ErrorPage = ({
  icon,
  title,
  message,
  actions,
}: ErrorPageProps) => {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] flex-col items-center justify-center py-12 text-center">
      <div className="text-muted-foreground mb-8 h-16 w-16">{icon}</div>
      <Heading variant="h2" className="mb-2">
        {title}
      </Heading>
      <Paragraph variant="body" className="text-muted-foreground mb-6">
        {message}
      </Paragraph>
      {actions && <>{actions}</>}
    </div>
  );
};
